import { IFinancingInsight } from "../types/ownerDashboard.types";

export function formatProjectionBasis(
  basis: IFinancingInsight["projection_basis"]
): string {
  if (basis === "current_rent") {
    return "Com base no aluguel líquido atual";
  }

  return "Projeção com base no IPCA (12 meses)";
}
